import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10">
        <div className="flex flex-col justify-between gap-12 md:flex-row md:items-end">
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/logo-mark.png" alt="DotIQ logo" className="h-8 w-8" />
              <span className="font-display text-2xl font-medium tracking-tight">DotIQ</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/45">
              Institutional intelligence for enterprises that expect their AI
              investment to compound.
            </p>
          </div>
          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="label-mono">Site</span>
              <Link to="/product" className="text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-product-link">Product</Link>
              <Link to="/#demo" className="text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-demo-link">Demo</Link>
              <Link to="/apply" className="text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-apply-link">Design Partners</Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="label-mono">Pillars</span>
              <span className="text-sm text-white/60">Context Graph</span>
              <span className="text-sm text-white/60">Correlation Engine</span>
              <span className="text-sm text-white/60">Change Observability</span>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-white/30 sm:flex-row sm:justify-between">
          <span>© 2026 DotIQ. All rights reserved.</span>
          <span>Institutional Intelligence, Made Concrete</span>
        </div>
      </div>
    </footer>
  );
}
